import React, {useContext} from 'react'
import { SectionContext } from "../context/sectionContext"
import { JourneyContext } from '../context/journeyContext'
import { getValueFromJourney ,getValueFromLookup} from '../services/helperFunctions'
import { lineCapital } from '../../shared/functions'

export default function ComponentBannarGSP(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  return (
    <>
      <div className="result-design summary-detail">
        <div className="col-md-12">
          <div className="total-premium-jeevan-design">
            <div className="total-meturity-jeevan">
              <h2 style={{ paddingLeft: "190px" }}>_ Guaranteed Maturity Benefit _</h2>
              <div className="line-jeev" />
            </div>
          </div>
          <div className="col-md-12 col-xs-12 pr pl-pr wd-total-metrurity">
            <div className="jeevan-neeves-premium">
              <div className="col-md-12">
              </div>
              <div className="" style={{ border: "2px solid white" }}>
                <div > <label style={{ paddingLeft: "40px" }}>Guranteed Sum Assured</label>
                  <span className="fa fa-rupee" style={{ paddingLeft: "400px" }}>{sectionState.sectionData["sumAssured"]}</span></div>
                <div><label style={{ paddingLeft: "40px" }}>Guranteed Additions </label>
                  <span className="fa fa-rupee" style={{ paddingLeft: "425px" }}>{sectionState.sectionData["GspAddition"]}</span></div>
                <div style={{ paddingLeft: "40px" }}>________________________________________________________________________________________</div>
                <div className="">
                  <label style={{ paddingLeft: "40px" }}> Total Amount</label>
                  <span className="fa fa-rupee" style={{ paddingLeft: "475px" }}>{sectionState.sectionData["totalAmount"]}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )

}



